import { SecuredKoppClient } from '../../Core/Api/Kopp/SecuredKoppClient';
import {
  SlimUser,
  LoginCommandRequest,
  CartItem,
  UpsertToCartCommandRequest,
  RemoveFromCartCommandRequest,
  EmptyCartCommandRequest,
} from '../../Core/Api/Kopp/Api';
import { Cart, GetCartCommandRequest, GetCartCommandResponse } from '../../Core/Api/Kopp/Api';

export class CartHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetCart(): Promise<GetCartCommandResponse | undefined> {
    const client = new SecuredKoppClient();
    const request = new GetCartCommandRequest();

    client.showLoading = false;
    client.handleSecurityError = false;
    client.handleGeneralError = false;
    return client.getCart(request).catch(x => {
      //Assume user not logged in and handle the error here
      return undefined;
    });
  }

  UpsertToCart(cartItem: CartItem) {
    const client = new SecuredKoppClient();
    client.showLoading = true;
    client.handleGeneralError = true;
    let request = new UpsertToCartCommandRequest();
    request.itemReference = cartItem.itemReference;
    request.pickupDate = cartItem.pickupDate;
    request.additionalInfo = cartItem.additionalInfo;
    request.cost = cartItem.cost;
    return client.upsertToCart(request);
  }

  RemoveFromCart(itemReference: string) {
    const client = new SecuredKoppClient();
    client.showLoading = true;
    client.handleGeneralError = true;
    let request = new RemoveFromCartCommandRequest();
    request.itemReference = itemReference;
    return client.removeFromCart(request);
  }

  EmptyCart() {
    const client = new SecuredKoppClient();
    client.showLoading = true;
    client.handleGeneralError = true;
    const request = new EmptyCartCommandRequest();
    return client.emptyCart(request);
  }
}
